import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseCrudService } from './base-crud.service';
import { CountryDto } from '../dtos/country.dto';
import { StateDto } from '../dtos/state.dto';
import { CountyDto } from '../dtos/county.dto';
import { SectionDto } from '../dtos/section.dto';
import { TownDto } from '../dtos/town.dto';
import { AddressTypeDto } from '../dtos/address-type.dto';
import { ZipFullDescDto } from '../dtos/zip-full-desc.dto';

@Injectable({ providedIn: 'root' })
export class ColonialLocationsService extends BaseCrudService<any> {
  // Base path /api/colonial/locations
  controller = 'colonial/locations';

  getCountries(): Observable<CountryDto[]> {
    return this.get<CountryDto[]>({}, 'countries');
  }

  getStates(): Observable<StateDto[]> {
    return this.get<StateDto[]>({}, 'states');
  }

  getCounties(): Observable<CountyDto[]> {
    return this.get<CountyDto[]>({}, 'counties');
  }

  getSections(): Observable<SectionDto[]> {
    return this.get<SectionDto[]>({}, 'sections');
  }

  getTowns(): Observable<TownDto[]> {
    return this.get<TownDto[]>({}, 'towns');
  }

  getAddressTypes(): Observable<AddressTypeDto[]> {
    return this.get<AddressTypeDto[]>({}, 'address-types');
  }

  getZipFullDescs(stateCode: number): Observable<ZipFullDescDto[]> {
    return this.get<ZipFullDescDto[]>({}, `states/${stateCode}/ziplocations`);
  }
}
